<template>
  <div id="depositOfDay">
    <div class="GridB0711BEB">
      <span :text="'100元起存，存期內按存款月數和存款金额靠檔計息，一次性存入本金，支持全部提前支取。'" class="textB24E4B66">
        {{$getFormat($t('label.label124'),minValue)}}
      </span>
      <span :text="'計息規則'" class="text0B03976A">
        {{$t('label.label122')}}
      </span>
      <span :text="' 按照存入當日我行APP產品頁面公佈的產品利率'" class="textB24E4B66">
        {{$t('label.label147')}}
        <br>
        {{$t('label.label148')}}
      </span>
      <span :text="'靠檔計付利息'" class="text0B03976A">
        {{$t('label.label149')}}
      </span>
      <span :text="'可全部提前支取，當存夠一檔月數計付對應的利息，未存夠下 一檔月數無利息。'" class="textB24E4B66">
        {{$t('label.label150')}}
        <br>
        {{$t('label.label151')}}
        <br>
        {{$t('label.label152')}}
      </span>
      <p class="buttonRight">
        <md-button :text="'示例'" :type="'primary'" :round="true" @click="isPopupShow= true">{{$t('btn.btn5')}}</md-button>
      </p>
    </div>
    <div class="GridB0837B9E">
      <div class="GridD3C6DC94">
        <p :text="'收益计算器'" class="textDA49B3C7">{{$t('label.label127')}}</p>
      </div>
      <div class="Grid8BF78CD1">
        <div class="Grid72A690B2">
          <div>
            <md-field-item
              :content="contentData[0].text"
              :arrow="false"
              :solid="true"
              :placeholder="$t('label.label128')"
              @click="showDialog"
            >
              <slot slot="right">
                <i class="iconfont iconArrowsV iconSpan"></i>
              </slot>
            </md-field-item>
          </div>
        </div>
        <div class="Grid72A690B2">
          <div>
            <md-field-item
              :content="contentData[1].text"
              :arrow="false"
              :solid="true"
              :placeholder="$t('label.label129')"
              @click="showDialog"
            >
              <slot slot="right">
                <i class="iconfont iconArrowsV iconSpan"></i>
              </slot>
            </md-field-item>
          </div>
        </div>
      </div>
      <div class="Grid8C4A69E8">
        <md-input-item
          :type="'text'"
          v-model="expectedValue"
          :align="'center'"
          :is-virtual-keyboard="true"
        />
        <div class="GridC2E6C2A8">
          <md-slider v-model="Slider21ED" :max="6" :min="1" :step="1" :format="format"></md-slider>
          <span :text="'拖动滑条选择您要存入的金额'" class="textE067D25D">{{$t('label.label130')}} <span class="trial" @click="trial">{{$t('btn.btn6')}}</span></span>
        </div>
        <span :text="'预计到期可获取收益'" class="span3">{{$t('label.label131')}}</span>
        <span :text="'0'" class="text1FE0515F">{{intersetResult}}</span>
      </div>
      <div class="Grid83489023">
        <md-button :text="'按钮'" :type="'primary'" :round="true" @click="buyPro">{{$t('label.label132')}}</md-button>
      </div>
    </div>
    <div class="componentArea">
      <md-popup
        v-model="isPopupShow"
        :hasMask="true"
        :mask-closable="true"
        position="top"
      >
        <div class="popArea">
          <p class="popP">
            {{$getFormat($t('label.label153'),'100')}}
          </p>
          <p class="spanOfP">
            <span>{{$t('label.label133')}}</span>
            <span>{{$t('label.label134')}}</span>
          </p>
          <div class="popStep">
            <md-steps :steps="steps">
              <template slot="unreached">
                <div class="iconOut">
                </div>
              </template>
              <template slot="current">
                <div class="iconOut">
                </div>
              </template>
              <template
                slot="content"
                slot-scope="{ step }"
              >
                <p class="pUp">{{step.name}}</p>
                <p class="pDown">{{step.money}}</p>
              </template>
            </md-steps>
          </div>
        </div>
      </md-popup>
    </div>
    <div class="dialogBoxModel" v-if="chooseArea.open">
      <div class="dialogBox">
        <div class="dialogHeader" slot="header">
          <span class="dialogSpan">{{$t('label.label177')}}</span>
          <span class="dialogSpan">{{$t('label.label178')}}</span>
          <!-- <span class="dialogSpan">存期</span> -->
        </div>
        <div class="dialogContent">
          <md-picker
            ref="picker"
            :data="chooseData"
            :default-index="contentIndex"
            :default-value="contentValue"
            :cols="2"
            :keep-index="true"
            :line-height="36"
            :is-view="true"
          ></md-picker>
        </div>
        <div class="dialogFooter">
          <span class="dialogFooterLeft" @click="cancle">{{$t('btn.btn2')}}</span>
          <span class="dialogFooterlRight" @click="setContentData">{{$t('btn.btn6')}}</span>
          <!-- <span class="dialogSpan">存期</span> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FieldItem, InputItem, Slider, Steps, Picker } from '@gidc/mobile'
import { Popup } from 'mand-mobile'
import { PREPURINTTRICAL } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'depositOfDay',
  components: {
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Slider.name]: Slider,
    [Popup.name]: Popup,
    [Steps.name]: Steps,
    [Picker.name]: Picker
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'prodClass',
      'buyProInfo'
    ])
  },
  data () {
    return {
      Slider21ED: 1,
      isPopupShow: false,
      steps: [
        {
          name: '2020-03-01',
          money: 'MOP10,000.00'
        },
        {
          name: '',
          money: ''
        },
        {
          name: '',
          money: ''
        },
        {
          name: '2020-03-08',
          money: 'MOP10,088.00'
        }
      ],
      chooseArea: {
        open: false,
        btns: [
          {
            text: this.$t('btn.btn2')
          },
          {
            text: this.$t('btn.btn1'),
            handler: this.setContentData
          }
        ]
      },
      chooseData: [],
      contentData: [{ text: '' }, { text: '' }], // 显示的币种 周期
      contentValue: [], // 选中的数据
      contentIndex: [], // 选中的标号
      contentDataValue: [],
      expectedValue: '', // 预期金额
      proInfo: '', // 产品信息
      intersetResult: '', // 试算结果,
      minValue: ''
    }
  },
  methods: {
    trial () {
      this.getInterest()
    },
    format (data) {
      switch (data) {
        case 1:
          this.expectedValue = '10000'
          break
        case 2:
          this.expectedValue = '20000'
          break
        case 3:
          this.expectedValue = '100000'
          break
        case 4:
          this.expectedValue = '200000'
          break
        case 5:
          this.expectedValue = '5000000'
          break
        case 6:
          this.expectedValue = '1000000'
          break
      }
    },
    buyPro () {
      this.$store.commit('buyProInfo', { ...this.buyProInfo, minValue: this.minValue, contentValue: this.contentValue, contentDataValue: this.contentDataValue, contentData: this.contentData, contentIndex: this.contentIndex })
      this.$router.push({ name: 'monthInformationEntry' })
    },
    getProInfo () {
      if (this.buyProInfo.contentData && this.buyProInfo.contentData !== []) {
        console.log('hello')
        const t = this.buyProInfo
        this.contentValue = t.contentValue
        this.contentDataValue = t.contentDataValue
        this.contentData = t.contentData
        this.contentIndex = t.contentIndex
        this.chooseData = [this.buyProInfo.cycResultList, this.buyProInfo.cycleList]
      } else {
        console.log('this.buyProInfo = ', this.buyProInfo)
        const cycleList = this.buyProInfo.cycleList
        const cycResultList = this.buyProInfo.cycResultList
        const arr = []
        for (const item in cycResultList) {
          if (this.buyProInfo.ccy.value === cycResultList[item].value) {
            console.log(item)
            arr[0] = item
          }
        }
        for (const item in cycleList) {
          if (this.buyProInfo.depositType.value === cycleList[item].value) {
            console.log(item)
            arr[1] = item
          }
        }
        this.contentValue = [cycResultList[arr[0]], cycleList[arr[1]]]
        this.contentIndex = arr
        this.contentDataValue = this.contentValue
        this.chooseData = [cycResultList, cycleList]
        this.contentData = [this.chooseData[0][arr[0]], this.chooseData[1][arr[1]]]
      }
      this.getMinValue()
    },
    getInterest (data) {
      const params = {
        prodType: 'FP01060004', // 产品类型日日赚：FP01060005，月月高：FP01060002
        ccy: this.contentDataValue[0].value, // 币种
        tranAmt: data || this.expectedValue, // 金额
        startDate: '', // 起存日期
        depositTerm: this.contentDataValue[1].value, // 存期
        agreementAmt: '', // 供款金额FP01060001零存整取智能存款上送
        floatValue: '', // 浮动值
        targetAmt: ''
      }
      this.$remote.post(PREPURINTTRICAL + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.intersetResult = res.intTotal
        })
    },
    showDialog () {
      this.chooseArea.open = true
    },
    cancle () {
      this.chooseArea.open = false
    },
    setContentData () {
      this.chooseArea.open = false
      this.contentValue = this.$refs.picker.getColumnValues()
      this.contentIndex = this.$refs.picker.getColumnIndexs()
      this.contentDataValue = this.$refs.picker.getColumnValues()
      this.contentData = this.$refs.picker.getColumnValues()
      this.getInterest()
    },
    getMinValue () {
      for (const item of this.buyProInfo.cycResultList) {
        if (item.value === this.contentDataValue[0].value) {
          this.minValue = item.minValue
          break
        }
      }
    }
  },
  created () {
    this.getProInfo()
    this.getInterest('10000')
    this.$route.meta.title1 = this.buyProInfo.prodDesc
  },
  mounted () {
  }
}
</script>
<style lang="stylus">
  #depositOfDay{
    .GridB0711BEB{
      .buttonRight{
        display flex
        justify-content  flex-end
        padding  0 .1rem .14rem 0
        .md-button{
          width auto
          height .41rem
        }
        .md-button.primary{
          background #EBF4FF
        }
        .md-button.primary::after{
          content none
        }
        .md-button-content{
          color #0076FF
          font-size .24rem
          font-weight 400
          line-height .33rem
          height .33rem
        }
      }
    }
    .GridB0837B9E{
      .Grid8BF78CD1{
        .Grid72A690B2{
          .md-field-item {
            .md-field-item-content {
              height .4rem
              line-height .4rem
              padding .1rem 0
              min-height 0
              .md-field-item-control {
                color #0C0C0C
                font-size .28rem
                font-weight 400
                line-height .4rem
                .md-field-item-placeholder {
                  color #9E9E9E
                  font-size .28rem
                  font-weight 400
                  line-height .4rem
                  height .4rem
                }
              }
            }
          }
        }
      }
      .Grid8C4A69E8{
        .md-field-item{
          .md-field-item-content{
            min-height 0
            .md-field-item-control{
              .md-input-item-fake{
                height: .6rem;
                line-height .5rem
                span{
                  line-height .4rem
                  height .4rem
                  font-size .28rem
                  font-weight 500
                  color #006CFF
                }
              }
            }
          }
        }
      }
      .Grid83489023{
        .md-button{
          border-radius .46rem
          height .92rem
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)
          .md-button-content{
            height .5rem
            line-height .5rem
            font-weight 500
            font-size .36rem
          }
        }
      }
    }
    .popArea{
      .md-steps.md-steps-horizontal{
        padding .1rem .4rem 1.5rem
      }
    }
  }
  .md-dialog-body{
    overflow hidden
    padding .3rem
    .md-picker-column-hooks{
      padding 0
    }
  }
</style>
<style lang="stylus" scoped>
  #depositOfDay{
    position: relative;
    .dialogBoxModel {
      z-index: 999;
      top 0
      position: absolute
      background: rgba(0,0,0,0.5)
      height 100%
      width: 100%;
      .dialogBox {
        background-color #fff
        width 6rem;
        height: 3rem;
        position: absolute
        top: 40%;
        left: 50%
        transform translate(-50%, -50%)
        .dialogHeader{
          height 1rem
          border-top-left-radius 0.1rem
          border-top-right-radius 0.1rem
          background: #F9FAFB;
          display flex
          align-items center
          padding 0 .6rem
          .dialogSpan{
            height .4rem
            font-size .28rem
            flex 1
            text-align center
          }
        }
        .dialogFooter {
          border-top: 1px solid #E2E4EA
          height 1rem
          background: #F9FAFB;
          display flex
          align-items center
          .dialogFooterLeft{
            height 1rem
            font-size .28rem
            line-height 1rem
            flex 1
            text-align center
            border-right 1px solid #E2E4EA
          }
          .dialogFooterlRight{
            height 1rem
            color: #3586F5;
            line-height 1rem
            font-size .28rem
            flex 1
            text-align center
          }
        }
      }
    }
    .GridB0711BEB{
      padding .3rem
      border-bottom .2rem solid #F8F8F8
      .textB24E4B66{
        font-size .28rem
        line-height .48rem
        color #0C0C0C
        display block
      }
      .text0B03976A{
        font-size .28rem
        font-weight bold
        line-height .48rem
        color #0C0C0C
        display block
      }
      .textB24E4B66+.text0B03976A{
        padding-top .7rem
      }
    }
    .GridB0837B9E{
      padding .52rem .3rem .3rem
      .GridD3C6DC94{
        display flex
        padding-bottom .1rem
        .textDA49B3C7{
          font-size .36rem
          line-height .5rem
          font-weight bold
          display inline-block
          color #1E1E26
        }
      }
      .Grid8BF78CD1{
        display:flex;
        height .9rem
        .Grid72A690B2{
          display flex
          flex auto
          justify-content center
          align-items center
          .iconSpan{
            font-size .28rem
            width .4rem
            height .4rem
            line-height .4rem
            color #1E1E1E
          }
        }
      }
      .Grid8C4A69E8{
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        padding-top:.4rem;
        background-size:100%;
        .text1FE0515F{
          font-size:.36rem;
          color:#FF6F00FF;
          padding-top .06rem
        }
        .span3{
          padding .81rem 0 0
          color #9E9E9E
          line-height .4rem
          height .4rem
          font-weight 400
          font-size .28rem
        }
        .GridC2E6C2A8{
          display flex
          flex-direction column
          justify-content center
          width 90%
          .trial {
            border 1px solid #2f86f6
            padding 0.03rem 0.1rem
            border-radius 0.4rem
          }
          .textE067D25D{
            padding-top .1rem
            text-align center
            color #3B8EFF
            font-size .24rem
            line-height .33rem
          }
        }
      }
      .Grid83489023{
        display:flex;
        flex-direction:row;
        padding 1rem .35rem .25rem .5rem
      }
    }
    .componentArea{
      .popArea{
        background-color white
        padding 1.1rem .3rem 0
        .popP{
          font-size .24rem
          line-height .4rem
          font-weight 400
          color #1E1E26
        }
        .spanOfP{
          height .4rem
          line-height .4rem
          justify-content space-between
          font-size .28rem
          display flex
          color #2B80F4
          font-weight 500
          padding-top .6rem
        }
        .popStep{
          .iconOut{
            width .12rem
            height .12rem
            background #0076FF
            box-shadow 0 0 .02rem .04rem rgb(195,223,255)
            border-radius .06rem
          }
          .pUp{
            font-size .2rem
            height 28px
            line-height 28px
            color #335B8F
            text-align center
            white-space nowrap
          }
          .pDown{
            font-size .2rem
            height 28px
            line-height 28px
            color #335B8F
            text-align center
            white-space nowrap
          }
        }
      }
    }
  }
  .dialogHeader{
    height 1rem
    background: #F9FAFB;
    display flex
    align-items center
    padding 0 .6rem
    .dialogSpan{
      height .4rem
      font-size .28rem
      flex 1
      text-align center
    }
  }
</style>
